require('../base')

$.widget('bijou.grid', $.bijou.base, {
  _create: function () {
    this._on({
      'click .js-grid-sidebar-trigger': this.toggleSidebar
    })
    this._on({
      'click .main-grid-content-backdrop': this.toggleSidebar
    })

    // Initial state
    $('.js-grid-sidebar-trigger:visible')
      .attr('aria-expanded', 'false')
      .attr('aria-controls', 'sidebar-wrapper')
    $('.main-sidebar:hidden').attr('aria-hidden', 'true')
  },

  sideBarA11y: function () {
    if ($('body').hasClass('grid-sidebar-on')) {
      $('.js-grid-sidebar-trigger').attr('aria-expanded', 'true')
      $('.js-main-grid-sidebar').attr('aria-hidden', 'false')
    } else {
      $('.js-grid-sidebar-trigger').attr('aria-expanded', 'false')
      $('.js-main-grid-sidebar').attr('aria-hidden', 'true')
    }
  },
  toggleSidebar: function () {
    document.querySelector('body').classList.toggle('grid-sidebar-on')
    document.querySelector('.main-grid-content-backdrop').classList.toggle('main-grid-content-backdrop-on')
    this.sideBarA11y()

    $('body').trigger('sidebarChange')
  }
})
